import { render, staticRenderFns } from "./fr.vue?vue&type=template&id=322fd3ae&scoped=true&"
import script from "./fr.vue?vue&type=script&lang=js&"
export * from "./fr.vue?vue&type=script&lang=js&"
import style0 from "./fr.vue?vue&type=style&index=0&id=322fd3ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322fd3ae",
  null
  
)

export default component.exports